'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLayoutCoordinatesValidator = exports.trimedProps = undefined;

var _ramda = require('ramda');

var R = _interopRequireWildcard(_ramda);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var trimedProps = exports.trimedProps = function trimedProps(properties, obj) {
  return R.reduce(function (acc, prop) {
    if (R.isNil(R.prop(prop, obj))) {
      return acc;
    }
    return R.append(obj[prop], acc);
  }, [], properties);
};

var getLayoutCoordinatesValidator = exports.getLayoutCoordinatesValidator = function getLayoutCoordinatesValidator(layoutCoordinates) {
  var topCoordinates = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (coordinates) {
    if (R.isEmpty(coordinates)) {
      return false;
    }
    if (R.has('OBS_ATTRIBUTES', layoutCoordinates) || R.has('OBS_ATTRIBUTES', topCoordinates)) {
      var obsAttrCoord = R.prop('OBS_ATTRIBUTES', layoutCoordinates) || R.prop('OBS_ATTRIBUTES', topCoordinates);
      if (obsAttrCoord !== 'OBS_VALUE') {
        return false;
      }
    }
    var keys = R.keys(coordinates);
    var res = true;
    var notInTop = {};
    R.forEach(function (key) {
      if (R.prop(key, layoutCoordinates) !== R.prop(key, coordinates)) {
        res = false;
      }
      if (!R.has(key, topCoordinates)) {
        notInTop[key] = key;
      }
    }, keys);
    return res && !R.isEmpty(notInTop);
  };
};